import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import { createContext, useContext, useState } from 'react';
import { SuccessIcon } from '@ninja/icons/web';
import { useWebUIConfigOptions } from './ThemeProvider2.js';
import { Toast } from './Toast3.js';

const toastContext = createContext({
    description: '',
    duration: 0,
    icon: SuccessIcon,
    isClosable: false,
    isShown: false,
    position: 'top-center',
    severity: 'success',
    showToast: () => undefined,
    title: '',
    width: 0,
});
const ToastProvider = ({ children }) => {
    const [contextValues, setContextValues] = useState({
        duration: 4000,
        isClosable: false,
        isShown: false,
        position: 'top-center',
        severity: 'success',
        title: '',
    });
    return (jsxs(toastContext.Provider, { value: Object.assign(Object.assign({}, contextValues), { showToast: (newValues) => {
                setContextValues(Object.assign(Object.assign(Object.assign({}, contextValues), newValues), { isShown: true }));
            } }), children: [jsx(Toast, Object.assign({ closeToast: () => setContextValues(Object.assign(Object.assign({}, contextValues), { isShown: false })) }, contextValues)), children] }));
};
const useToast = () => {
    const { showToast } = useContext(toastContext);
    const { toastDefaults } = useWebUIConfigOptions();
    const _a = toastDefaults !== null && toastDefaults !== void 0 ? toastDefaults : {}, { defaultsIcons = {} } = _a, defaultProps = __rest(_a, ["defaultsIcons"]);
    const { error, info, success, warning } = defaultsIcons;
    const onShowToast = (props, severity, defaultIcon) => {
        if (props) {
            if (typeof props === 'string') {
                showToast(Object.assign(Object.assign({}, defaultProps), { icon: defaultIcon, title: props, severity }));
            }
            else {
                showToast(Object.assign(Object.assign(Object.assign(Object.assign({}, defaultProps), { icon: defaultIcon }), props), { severity }));
            }
        }
    };
    return {
        showError: (props) => {
            onShowToast(props, 'error', error);
        },
        showSuccess: (props) => {
            onShowToast(props, 'success', success);
        },
        showWarning: (props) => {
            onShowToast(props, 'warning', warning);
        },
        showInfo: (props) => {
            onShowToast(props, 'info', info);
        },
    };
};

export { ToastProvider, useToast };
